// phonics_data_vv.js
// Song/Chant 来源: F:\17talkxyz\Phonics_AtoZ\AtoZ_mp4\Vv.mp4 (00:10 - 01:52，即 startTime:10, endTime:112)
// Story 1/2/3/4 来源: F:\17talkxyz\Phonics_AtoZ\Letter Vv\Vv1/2/3/4.mp4 (完整)

const MEDIA_BASE = '/media/phonics/vv';

const letterDataVv = {
  letter: 'Vv',
  coverBg: `${MEDIA_BASE}/image1.jpeg`,
  coverPoster: `${MEDIA_BASE}/Vv.png`,

  songVideo: {
    src: `${MEDIA_BASE}/Vv.mp4`,
    poster: `${MEDIA_BASE}/Vv.png`,
    startTime: 10,
    endTime: 112,
  },

  wordVideos: [
    // 4格词汇: van/vase/vest/violin，poster 从 PPT slide4 rels 确认
    // 上左=van(image10), 上右=vase(image9), 下左=vest(image8), 下右=violin(image11)
    { src: `${MEDIA_BASE}/video_s3_word1.mp4`, poster: `${MEDIA_BASE}/image10.png`, word: 'van',     wordCn: '货车' },
    { src: `${MEDIA_BASE}/video_s3_word2.mp4`, poster: `${MEDIA_BASE}/image9.png`,  word: 'vase',   wordCn: '花瓶' },
    { src: `${MEDIA_BASE}/video_s3_word3.mp4`, poster: `${MEDIA_BASE}/image8.png`,  word: 'vest',   wordCn: '背心' },
    { src: `${MEDIA_BASE}/video_s3_word4.mp4`, poster: `${MEDIA_BASE}/image11.png`, word: 'violin', wordCn: '小提琴' },
  ],

  storySections: [
    // Story 1: 5个词汇 + 4句故事
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_1.mp4`, poster: `${MEDIA_BASE}/image13.png` },
      ],
      splitAt: 5,
      lines: [
        { en: "Let's",         cn: '让我们去购物吧', audioEn: `${MEDIA_BASE}/w_en_let's.mp3`,  audioCn: `${MEDIA_BASE}/w_cn_let's.mp3` },
        { en: 'mom',           cn: '妈妈',           audioEn: `${MEDIA_BASE}/w_en_mom.mp3`,     audioCn: `${MEDIA_BASE}/w_cn_mom.mp3` },
        { en: 'get',           cn: '买',             audioEn: `${MEDIA_BASE}/w_en_get.mp3`,     audioCn: `${MEDIA_BASE}/w_cn_get.mp3` },
        { en: 'got',           cn: '买了',           audioEn: `${MEDIA_BASE}/w_en_got.mp3`,     audioCn: `${MEDIA_BASE}/w_cn_got.mp3` },
        { en: 'love',          cn: '很喜欢',         audioEn: `${MEDIA_BASE}/w_en_love.mp3`,    audioCn: `${MEDIA_BASE}/w_cn_love.mp3` },
        { en: "Let's go shopping.",          cn: '让我们去购物吧。',         audioEn: `${MEDIA_BASE}/story1_en_1.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3` },
        { en: "What did you get, Mom?",     cn: '妈妈，你买了什么？',       audioEn: `${MEDIA_BASE}/story1_en_2.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3` },
        { en: "I got a vase.",               cn: '我买了一个花瓶。',         audioEn: `${MEDIA_BASE}/story1_en_3.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3` },
        { en: "Oh, I love the vase.",       cn: '我很喜欢这个花瓶。',       audioEn: `${MEDIA_BASE}/story1_en_4.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_4.mp3` },
      ],
    },
    // Story 2: 1个词汇 + 3句故事
    {
      label: 'Learn the Story (2)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_2.mp4`, poster: `${MEDIA_BASE}/image14.png` },
      ],
      splitAt: 1,
      lines: [
        { en: 'Violet', cn: 'Violet（人名）', audioEn: `${MEDIA_BASE}/w_en_violet.mp3`, audioCn: `${MEDIA_BASE}/w_cn_violet.mp3` },
        { en: "What did you get, Violet?", cn: 'Violet，你买了什么？', audioEn: `${MEDIA_BASE}/story2_en_1.mp3`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3` },
        { en: "I got a vest.",              cn: '我买了一件背心。',       audioEn: `${MEDIA_BASE}/story2_en_2.mp3`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3` },
        { en: "Oh, I love the vest.",       cn: '我很喜欢这件背心。',     audioEn: `${MEDIA_BASE}/story2_en_3.mp3`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3` },
      ],
    },
    // Story 3: 1个词汇 + 3句故事
    {
      label: 'Learn the Story (3)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_3.mp4`, poster: `${MEDIA_BASE}/image15.png` },
      ],
      splitAt: 1,
      lines: [
        { en: 'Victor', cn: 'Victor（人名）', audioEn: `${MEDIA_BASE}/w_en_victor.mp3`, audioCn: `${MEDIA_BASE}/w_cn_victor.mp3` },
        { en: "What did you get, Victor?", cn: 'Victor，你买了什么？', audioEn: `${MEDIA_BASE}/story3_en_1.mp3`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3` },
        { en: "I got a violin.",            cn: '我买了一把小提琴。',    audioEn: `${MEDIA_BASE}/story3_en_2.mp3`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3` },
        { en: "Oh, we love the violin.",   cn: '我们很喜欢这把小提琴。', audioEn: `${MEDIA_BASE}/story3_en_3.mp3`, audioCn: `${MEDIA_BASE}/story3_cn_3.mp3` },
      ],
    },
    // Story 4: 1个词汇 + 3句故事
    {
      label: 'Learn the Story (4)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_4.mp4`, poster: `${MEDIA_BASE}/image16.png` },
      ],
      splitAt: 1,
      lines: [
        { en: 'Dad', cn: '爸爸', audioEn: `${MEDIA_BASE}/w_en_dad.mp3`, audioCn: `${MEDIA_BASE}/w_cn_dad.mp3` },
        { en: "What did you get, Dad?", cn: '爸爸，你买了什么？', audioEn: `${MEDIA_BASE}/story4_en_1.mp3`, audioCn: `${MEDIA_BASE}/story4_cn_1.mp3` },
        { en: "I got a van.",           cn: '我买了一辆货车。',     audioEn: `${MEDIA_BASE}/story4_en_2.mp3`, audioCn: `${MEDIA_BASE}/story4_cn_2.mp3` },
        { en: "Oh, we love the van.",   cn: '我们很喜欢这辆货车。',  audioEn: `${MEDIA_BASE}/story4_en_3.mp3`, audioCn: `${MEDIA_BASE}/story4_cn_3.mp3` },
      ],
    },
  ],
};

export default letterDataVv;
